/** localStorage key used by the organization zustand persist store. */
export const ORG_STORAGE_KEY = "hivly-org";
